const Sdata =[
    {   
        id:1,
        imgsrc:"https://wallpapercave.com/wp/wp4056410.jpg",
         title:"A Netflix Orginal Series",
        sname : "DARK",
        link:"https://www.netflix.com/in/title/80990668?source=35",
    },{
        id:2,
        imgsrc:"https://tse3.mm.bing.net/th?id=OIP.y7gvtp3WhWmFllb8YiFURAHaK-&pid=Api&P=0&h=220.jpg",
         title:"A Netflix Orginal Series",
        sname : "extra curricular",
        link:"https://www.netflix.com/in/title/80990668?source=35"
    },{
        id:3,
        imgsrc:"https://tse4.mm.bing.net/th?id=OIP.r9UL2uilziF54DY23i6NKwHaDq&pid=Api&P=0&h=220.jpg" ,
        title:"A Netflix Orginal Series",
        sname : "Stranger Things",
        link:"https://www.netflix.com/in/title/80990668?source=35"
    },{
        id:4,
        imgsrc:"https://tse3.mm.bing.net/th?id=OIP.MjjCXMW9RhO69I9gQPxPqQHaEo&pid=Api&P=0&h=220.jpg",
        title:"A Netflix Orginal Series",
        sname :"The Vampire Diaries",
        link:"https://www.netflix.com/in/title/80990668?source=35"
    },{
        id:5,
        imgsrc:"https://tse1.mm.bing.net/th?id=OIP.0ejY_PxW2HhhyhOzPCkUdgHaEK&pid=Api&rs=1&c=1&qlt=95&h=220.",
        title:"A Netflix Orginal Series",
        sname: "My First 2 love",
        link:"https://www.netflix.com/in/title/80990668?source=35"
    }
    ]
    
    export default Sdata;